module.exports = new __parcel__URL__("hyperpay.b038c996.svg").toString();